"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeOffRequestStatusLabels = exports.TimeOffRequestStatus = exports.CompanyHolidayType = exports.PTOPolicyAccrualType = exports.PTOPolicyType = exports.CustomPropertyType = exports.RoleType = exports.EmployeeType = exports.SyncProgress = exports.EmbeddedStatus = exports.RequestErrorCode = void 0;
var RequestErrorCode;
(function (RequestErrorCode) {
    RequestErrorCode["ENTITY_NOT_FOUND"] = "ENTITY_NOT_FOUND";
    RequestErrorCode["ENTITY_NOT_CREATED"] = "ENTITY_NOT_CREATED";
    RequestErrorCode["ENTITY_NOT_UPDATED"] = "ENTITY_NOT_UPDATED";
    RequestErrorCode["ENTITY_NOT_DELETED"] = "ENTITY_NOT_DELETED";
    RequestErrorCode["PROCESS_ERROR"] = "PROCESS_ERROR";
    RequestErrorCode["NO_FILE_PRESENT"] = "NO_FILE_PRESENT";
    RequestErrorCode["AUTH_INCORRECT_PASSWORD"] = "AUTH_INCORRECT_PASSWORD";
    RequestErrorCode["AUTH_NO_USER_FOUND"] = "AUTH_NO_USER_FOUND";
    RequestErrorCode["AUTH_FAILED"] = "AUTH_FAILED";
    RequestErrorCode["EMAIL_NOT_VERIFIED"] = "EMAIL_NOT_VERIFIED";
    RequestErrorCode["INVALID_FILE_TYPE"] = "INVALID_FILE_TYPE";
    RequestErrorCode["AUTH_SYSTEM_USER"] = "AUTH_SYSTEM_USER";
})(RequestErrorCode || (exports.RequestErrorCode = RequestErrorCode = {}));
var EmbeddedStatus;
(function (EmbeddedStatus) {
    EmbeddedStatus["NOT_PROCESSED"] = "NOT_PROCESSED";
    EmbeddedStatus["PROCESSED"] = "PROCESSED";
    EmbeddedStatus["TOO_LARGE"] = "TOO_LARGE";
    EmbeddedStatus["FORMAT_NOT_SUPPORTED"] = "FORMAT_NOT_SUPPORTED";
    EmbeddedStatus["NO_CONTENT"] = "NO_CONTENT";
    EmbeddedStatus["SYSTEM_OUTAGE"] = "SYSTEM_OUTAGE";
    EmbeddedStatus["UNKNOWN"] = "UNKNOWN";
})(EmbeddedStatus || (exports.EmbeddedStatus = EmbeddedStatus = {}));
var SyncProgress;
(function (SyncProgress) {
    SyncProgress["NOT_PROCESSING"] = "NOT_PROCESSING";
    SyncProgress["ERRORED"] = "ERRORED";
    SyncProgress["PROCESSING"] = "PROCESSING";
    SyncProgress["UP_TO_DATE"] = "UP_TO_DATE";
})(SyncProgress || (exports.SyncProgress = SyncProgress = {}));
// export type EmployeeType =
//   "US Full Time" | "US Part Time" | "US Contractor" |
//   "US Intern" | "International Full Time" | "International Contractor";
var EmployeeType;
(function (EmployeeType) {
    EmployeeType["US_FULL_TIME"] = "US_FULL_TIME";
    EmployeeType["US_PART_TIME"] = "US_PART_TIME";
    EmployeeType["US_CONTRACTOR"] = "US_CONTRACTOR";
    EmployeeType["US_VENDOR"] = "US_VENDOR";
    EmployeeType["INT_FULL_TIME"] = "INT_FULL_TIME";
    EmployeeType["INT_CONTRACTOR"] = "INT_CONTRACTOR";
})(EmployeeType || (exports.EmployeeType = EmployeeType = {}));
var RoleType;
(function (RoleType) {
    RoleType["ADMIN"] = "ADMIN";
    RoleType["MANAGER"] = "MANAGER";
    RoleType["EMPLOYEE"] = "EMPLOYEE";
})(RoleType || (exports.RoleType = RoleType = {}));
var CustomPropertyType;
(function (CustomPropertyType) {
    CustomPropertyType["SHORT"] = "SHORT";
    CustomPropertyType["LONG"] = "LONG";
    CustomPropertyType["RICH"] = "RICH";
    CustomPropertyType["PHONE"] = "PHONE";
    CustomPropertyType["NUMBER"] = "NUMBER";
    CustomPropertyType["EMAIL"] = "EMAIL";
    CustomPropertyType["EMPLOYEE_RECORD"] = "EMPLOYEE_RECORD";
    CustomPropertyType["PTO_POLICIES"] = "PTO_POLICIES";
    CustomPropertyType["DATE"] = "DATE";
    CustomPropertyType["CHECKBOX_SINGLE"] = "CHECKBOX_SINGLE";
    CustomPropertyType["CHECKBOX_MULTIPLE"] = "CHECKBOX_MULTIPLE";
    CustomPropertyType["DROPDOWN"] = "DROPDOWN";
    CustomPropertyType["RADIO"] = "RADIO";
    CustomPropertyType["FILE"] = "FILE";
})(CustomPropertyType || (exports.CustomPropertyType = CustomPropertyType = {}));
var PTOPolicyType;
(function (PTOPolicyType) {
    PTOPolicyType["VACATION"] = "VACATION";
    PTOPolicyType["SICK"] = "SICK";
    PTOPolicyType["OTHER"] = "OTHER";
})(PTOPolicyType || (exports.PTOPolicyType = PTOPolicyType = {}));
var PTOPolicyAccrualType;
(function (PTOPolicyAccrualType) {
    PTOPolicyAccrualType["BY_DAYS"] = "BY_DAYS";
    PTOPolicyAccrualType["UPFRONT"] = "UPFRONT";
    PTOPolicyAccrualType["BY_HOURS"] = "BY_HOURS";
    PTOPolicyAccrualType["UNLIMITED"] = "UNLIMITED";
})(PTOPolicyAccrualType || (exports.PTOPolicyAccrualType = PTOPolicyAccrualType = {}));
var CompanyHolidayType;
(function (CompanyHolidayType) {
    CompanyHolidayType["DATE"] = "DATE";
    CompanyHolidayType["LAST"] = "LAST";
    CompanyHolidayType["NTH"] = "NTH";
    CompanyHolidayType["DAY_AFTER"] = "DAY_AFTER";
})(CompanyHolidayType || (exports.CompanyHolidayType = CompanyHolidayType = {}));
var TimeOffRequestStatus;
(function (TimeOffRequestStatus) {
    TimeOffRequestStatus["PENDING"] = "PENDING";
    TimeOffRequestStatus["APPROVED"] = "APPROVED";
    TimeOffRequestStatus["REJECTED"] = "REJECTED";
    TimeOffRequestStatus["CANCELLED"] = "CANCELLED";
})(TimeOffRequestStatus || (exports.TimeOffRequestStatus = TimeOffRequestStatus = {}));
exports.TimeOffRequestStatusLabels = {
    [TimeOffRequestStatus.PENDING]: "Pending",
    [TimeOffRequestStatus.APPROVED]: "Approved",
    [TimeOffRequestStatus.REJECTED]: "Rejected",
    [TimeOffRequestStatus.CANCELLED]: "Cancelled",
};
